import type { Order } from '@/mocks/orders';
import { statusLabels, statusColors } from '@/mocks/orders';

interface OrderTableProps {
  orders: Order[];
  onSelect: (order: Order) => void;
}

export default function OrderTable({ orders, onSelect }: OrderTableProps) {
  return (
    <div className="bg-white rounded-xl border border-stone-200/80 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-stone-100 bg-stone-50/50">
              <th className="text-left text-xs font-semibold text-stone-500 px-4 py-3 whitespace-nowrap">Sipariş ID</th>
              <th className="text-left text-xs font-semibold text-stone-500 px-4 py-3 whitespace-nowrap">Müşteri</th>
              <th className="text-left text-xs font-semibold text-stone-500 px-4 py-3 whitespace-nowrap">Telefon</th>
              <th className="text-left text-xs font-semibold text-stone-500 px-4 py-3 whitespace-nowrap">İl</th>
              <th className="text-left text-xs font-semibold text-stone-500 px-4 py-3 whitespace-nowrap">Ürün</th>
              <th className="text-center text-xs font-semibold text-stone-500 px-4 py-3 whitespace-nowrap">Adet</th>
              <th className="text-right text-xs font-semibold text-stone-500 px-4 py-3 whitespace-nowrap">Tutar</th>
              <th className="text-center text-xs font-semibold text-stone-500 px-4 py-3 whitespace-nowrap">Ödeme</th>
              <th className="text-left text-xs font-semibold text-stone-500 px-4 py-3 whitespace-nowrap">Durum</th>
              <th className="text-center text-xs font-semibold text-stone-500 px-4 py-3 whitespace-nowrap">Aksiyon</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-stone-50">
            {orders.length === 0 ? (
              <tr>
                <td colSpan={10} className="px-4 py-12 text-center text-sm text-stone-400">
                  <i className="ri-inbox-line text-2xl block mb-2" />
                  Filtrelere uygun sipariş bulunamadı.
                </td>
              </tr>
            ) : (
              orders.map((order) => (
                <tr
                  key={order.id}
                  className="hover:bg-stone-50/50 transition-colors cursor-pointer group"
                  onClick={() => onSelect(order)}
                >
                  <td className="px-4 py-3">
                    <span className="text-xs font-mono font-semibold text-stone-800 whitespace-nowrap">{order.id}</span>
                    {order.isUrgent && (
                      <span className="ml-1.5 text-[10px] bg-status-red/10 text-status-red px-1 py-0.5 rounded font-medium pulse-warning">ACİL</span>
                    )}
                  </td>
                  <td className="px-4 py-3">
                    <span className="text-sm font-medium text-stone-800 whitespace-nowrap">{order.customerName}</span>
                  </td>
                  <td className="px-4 py-3">
                    <span className="text-xs text-stone-500 whitespace-nowrap">{order.phone.replace('90', '0')}</span>
                  </td>
                  <td className="px-4 py-3">
                    <span className="text-xs text-stone-500 whitespace-nowrap">{order.city}</span>
                  </td>
                  <td className="px-4 py-3">
                    <span className="text-xs text-stone-600 max-w-[180px] truncate block">{order.productName}</span>
                  </td>
                  <td className="px-4 py-3 text-center">
                    <span className="text-xs text-stone-600">{order.quantity}</span>
                  </td>
                  <td className="px-4 py-3 text-right">
                    <span className="text-sm font-semibold text-stone-800 whitespace-nowrap">{order.amount.toLocaleString('tr-TR')} ₺</span>
                  </td>
                  <td className="px-4 py-3 text-center">
                    <span className={`inline-flex items-center text-xs font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${
                      order.paymentStatus === 'tahsil_edildi' ? 'bg-status-green/10 text-status-green' :
                      order.paymentStatus === 'bekleniyor' ? 'bg-status-orange/10 text-status-orange' :
                      'bg-status-gray/10 text-status-gray'
                    }`}>
                      {order.paymentType === 'kapida_odeme' ? 'Kapıda' : order.paymentType === 'havale' ? 'Havale' : 'K.Kartı'}
                    </span>
                  </td>
                  <td className="px-4 py-3">
                    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${statusColors[order.status]} whitespace-nowrap`}>
                      {statusLabels[order.status]}
                    </span>
                  </td>
                  <td className="px-4 py-3">
                    <div className="flex items-center justify-center gap-1">
                      <a
                        href={`https://wa.me/${order.phone}`}
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        onClick={(e) => e.stopPropagation()}
                        className="w-7 h-7 flex items-center justify-center rounded-md bg-green-50 text-green-600 hover:bg-green-100 transition-colors cursor-pointer"
                        title="WhatsApp"
                      >
                        <i className="ri-whatsapp-line text-sm" />
                      </a>
                      <button
                        onClick={(e) => { e.stopPropagation(); onSelect(order); }}
                        className="w-7 h-7 flex items-center justify-center rounded-md bg-stone-100 text-stone-500 hover:bg-stone-200 transition-colors cursor-pointer"
                        title="Detay"
                      >
                        <i className="ri-arrow-right-s-line text-sm" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}